import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';

import { FetchItems } from '../exact.actions';
import { ExactState } from '../exact.state';

@Component({
    selector: 'app-exact-products',
    templateUrl: './exact-products.component.html',
    styleUrls: ['./exact-products.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ExactProductsComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(ExactState.loggedIn) loggedIn$: Observable<boolean>;
    @Select(ExactState.items) items$: Observable<any[]>;
    filter: string;
    isset = true;

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.subscriptions.add(
            this.loggedIn$.subscribe((loggedIn) => {
                if (loggedIn) {
                    this.store.dispatch(new FetchItems()).subscribe();
                }
            }),
        );
    }

    checkCredentials(set: boolean) {
        this.isset = set;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
